import React, { useState } from 'react'
import styles from './ShoppingCart.module.scss'
import { updateCartItem, removeCartItem, createOrderFromCart } from '../../../../../service/ShopService'
import { ShoppingCartIcon, TrashIcon, CheckIcon, LockIcon } from 'components/CustomIcons'

const ShoppingCart = ({ cart, onUpdateCart, onBackToShopping, isAuthenticated }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [orderSuccess, setOrderSuccess] = useState(false)

  if (orderSuccess) {
    return (
      <div className={styles.successMessage}>
        <div className={styles.successIcon}>
          <CheckIcon size={64} style={{ color: '#4CAF50' }} />
        </div>
        <h2>Заявка успешно оставлена!</h2>
        <p>Скоро с вами свяжутся наши менеджеры</p>
        <button onClick={onBackToShopping} className={styles.shopButton}>
          Вернуться к покупкам
        </button>
      </div>
    )
  }

  if (!isAuthenticated) {
    return (
      <div className={styles.emptyCart}>
        <div className={styles.emptyIcon}>
          <LockIcon size={64} />
        </div>
        <h3>Требуется авторизация</h3>
        <p>Войдите в систему, чтобы использовать корзину</p>
        <button onClick={() => window.location.href = '/login'} className={styles.shopButton}>
          Войти
        </button>
      </div>
    )
  }

  if (!cart || !cart.items || cart.items.length === 0) {
    return (
      <div className={styles.emptyCart}>
        <ShoppingCartIcon className={styles.emptyIcon} size={64} />
        <h3>Ваша корзина пуста</h3>
        <p>Добавьте товары из каталога</p>
        <button onClick={onBackToShopping} className={styles.shopButton}>
          Перейти к покупкам
        </button>
      </div>
    )
  }

  const handleUpdateQuantity = async (itemId, newQuantity) => {
    if (newQuantity < 1) return
    try {
      setLoading(true)
      setError(null)
      await updateCartItem(itemId, newQuantity)
      // Обновляем локально
      const updatedCart = {
        ...cart,
        items: cart.items.map(item =>
          item.id === itemId ? { ...item, quantity: newQuantity } : item
        )
      }
      onUpdateCart(updatedCart)
    } catch (err) {
      setError('Ошибка обновления количества')
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const handleRemoveItem = async (itemId) => {
    try {
      setLoading(true)
      setError(null)
      await removeCartItem(itemId)
      // Обновляем локально
      const updatedCart = {
        ...cart,
        items: cart.items.filter(item => item.id !== itemId)
      }
      onUpdateCart(updatedCart)
    } catch (err) {
      setError('Ошибка удаления товара')
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const handleCheckout = async () => {
    try {
      setLoading(true)
      setError(null)
      await createOrderFromCart({
        notes: 'Заказ из магазина'
      })
      setOrderSuccess(true)
      onUpdateCart({ items: [] }) // Очищаем корзину
    } catch (err) {
      setError('Ошибка создания заказа. Попробуйте позже.')
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const totalPrice = cart.items.reduce(
    (sum, item) => sum + (item.unit_price_snapshot || item.product?.price || 0) * item.quantity, 
    0
  )

  return (
    <div className={styles.cart}>
      {error && (
        <div className={styles.errorMessage}>
          {error}
        </div>
      )}

      <div className={styles.cartItems}>
        {cart.items.map((item) => (
          <div key={item.id} className={styles.cartItem}>
            <div className={styles.itemImage}>
              <img 
                src={item.product?.main_image || item.product?.image || '/placeholder-product.jpg'} 
                alt={item.product?.name} 
              />
            </div>
            
            <div className={styles.itemInfo}>
              <h4>{item.product?.name}</h4>
              <p>{item.unit_price_snapshot || item.product?.price} сом</p>
            </div>
            
            <div className={styles.itemQuantity}>
              <button 
                onClick={() => handleUpdateQuantity(item.id, item.quantity - 1)}
                disabled={loading || item.quantity <= 1}
              >
                -
              </button>
              <span>{item.quantity}</span>
              <button 
                onClick={() => handleUpdateQuantity(item.id, item.quantity + 1)}
                disabled={loading}
              >
                +
              </button>
            </div>
            
            <div className={styles.itemTotal}>
              {((item.unit_price_snapshot || item.product?.price || 0) * item.quantity).toFixed(2)} сом
            </div>
            
            <button 
              className={styles.removeButton}
              onClick={() => handleRemoveItem(item.id)}
              disabled={loading}
            >
              <TrashIcon size={20} />
            </button>
          </div>
        ))}
      </div>
      
      <div className={styles.cartSummary}>
        <div className={styles.total}>
          <h3>Итого: {totalPrice.toFixed(2)} сом</h3>
        </div>
        
        <div className={styles.actions}>
          <button onClick={onBackToShopping} className={styles.continueButton}>
            Продолжить покупки
          </button>
          <button 
            className={styles.checkoutButton}
            onClick={handleCheckout}
            disabled={loading}
          >
            {loading ? 'Обработка...' : 'Оставить заявку'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ShoppingCart